import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import {
  formatDate,
  currencyFormat,
  formatDateTime,
} from "../../../../function/commonFunction";
import { Button, Menu, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ExpiryDateFilter from "../../../pages/propertyList/ExpiryDateFilter";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";

export const PendingInvoiceTable = ({
  column,
  rowsArr,
  handleActionPending,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  totalCount,
  handleActionMultipleApprove,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  tab,
  setPageSizePending,
  setFilterType,
}) => {
  const { permissionArr } = useSelector((state) => state.auth);
  const { permissions } = useSelector((state) => state.permissionsData);

  const dispatch = useDispatch();

  const columns = useMemo(() => column, [column]);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [labels, setLabels] = useState([]);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
  const [totalAmount, setTotalAmount] = useState(0);

  
  const handleCheckboxChange = (row) => {
    setCheckedRows((prev) => {
      let updatedCheckedRows;
      if (prev.includes(row.id)) {
        updatedCheckedRows = prev.filter((id) => id !== row.id);
      } else {
        updatedCheckedRows = [...prev, row.id];
      }
  
      // Calculate total amount for selected rows
      const selectedTotal = rows
        .filter((r) => updatedCheckedRows.includes(r.id))
        .reduce((sum, r) => sum + (r.original.TotalAmount || 0), 0); // Ensure TotalAmount exists
  
      setTotalAmount(selectedTotal);
      return updatedCheckedRows;
    });
  };

  // const handleCheckboxChange = (row) => {
  //   setCheckedRows((prev) => {
  //     if (prev.includes(row.id)) {
  //       return prev.filter((id) => id !== row.id);
  //     } else {
  //       return [...prev, row.id];
  //     }
  //   });
  // };

  useEffect(() => {
    if (tab !== "New") {
      setCheckedRows([]);
    }
    if (checkedRows.length === 0) {
      setIsAllChecked(false);
    }
  }, [checkedRows, tab]);

  const handleHeaderCheckboxChange = () => {
    setIsAllChecked((prev) => !prev);
    if (!isAllChecked) {
      // Select only rows where CanApprove is true
      const approvedRows = rows.filter((row) => row.original);
      const approvedRowIds = approvedRows.map((row) => row.id);
  
      setCheckedRows(approvedRowIds);
  
      // Calculate total TotalAmount for approved rows
      const selectedTotal = approvedRows.reduce((sum, row) => sum + (row.original.TotalAmount || 0), 0);
      setTotalAmount(selectedTotal);
    } else {
      // Deselect all rows
      setCheckedRows([]);
      setTotalAmount(0);
    }
  };

  // const handleHeaderCheckboxChange = () => {
  //   setIsAllChecked((prev) => !prev);
  //   if (!isAllChecked) {
  //     setCheckedRows(rows.map((row) => row.id));
  //   } else {
  //     setCheckedRows([]);
  //   }
  // };

  const getCheckedRows = () => {
    return rows
      .filter((row) => checkedRows.includes(row.id))
      .map((row) => row.original);
  };

  const toggleRowExpansion = (index, expandedRowData) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
    // setLabels([
    //   { key: "Location Address", value: expandedRowData.SupplierAddress },
    //   { key: "Remarks", value: expandedRowData.Remark },
    //   { key: "Invoice Due Date", value: formatDate(expandedRowData.InvoiceDueDate) },
    //   { key: "Amount", value: currencyFormat(expandedRowData.Amount) },
    //   { key: "Tax Amount", value: currencyFormat(expandedRowData.TotalTaxValue) },
    //   { key: "Total Amount", value: currencyFormat(expandedRowData.TotalAmount) },
    // ])
    const labels = [
      { key: "Location Address", value: expandedRowData.SupplierAddress },
      { key: "Remarks", value: expandedRowData.Remark },
      {
        key: "Invoice Due Date",
        value: formatDate(expandedRowData.InvoiceDueDate),
      },
      // { key: "Amount", value: currencyFormat(expandedRowData.Amount) },
      {
        key: "Tax Amount",
        value: currencyFormat(expandedRowData.TotalTaxValue),
      },
      // { key: "Total Amount", value: currencyFormat(expandedRowData.TotalAmount) },
    ];

    // Add "Amount" label only if InvoiceType is not "Telephone"
    if (!expandedRowData.InvoiceType.includes("Telephone")) {
      labels.push({
        key: "Bill Amount",
        value: currencyFormat(expandedRowData.Amount),
      });
    }
    if (expandedRowData.InvoiceType.includes("Telephone")) {
      labels.push({ key: "Circle", value: expandedRowData.Circle });
      labels.push({ key: "Account Number", value: expandedRowData.AccountNo });
      labels.push({
        key: "Location Address",
        value: expandedRowData.LocationAddress,
      });
    }
    const filteredLabels = labels.filter((label) => label.value !== null);

    setLabels(filteredLabels);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) =>
    submenu?.Actions.includes(actionName);

  // Find the "Invoice" menu
  const propertiesMenu = findSubMenuByName(permissions, "Invoice");
  const listPropertyMenu = propertiesMenu
    ? findSubMenuByName(propertiesMenu?.SubMenus, "Invoice List")
    : null;
  const approvedSubMenu = listPropertyMenu
    ? findSubMenuByName(listPropertyMenu?.SubMenus, "New")
    : null;
  // Check actions in the "New" submenu
  const canApprove = approvedSubMenu
    ? hasAction(approvedSubMenu, "SubmitForApproval")
    : false;
  const canSearch = approvedSubMenu
    ? hasAction(approvedSubMenu, "Search")
    : false;
  const canAudittrial = approvedSubMenu
    ? hasAction(approvedSubMenu, "Audittrial")
    : false;
  const canEdit = approvedSubMenu ? hasAction(approvedSubMenu, "Edit") : false;
  const canReject = approvedSubMenu
    ? hasAction(approvedSubMenu, "Reject")
    : false;
  const MoreFilterSubMenu = listPropertyMenu
    ? findSubMenuByName(listPropertyMenu?.SubMenus, "MoreFilters")
    : null;
  const invoiceType = MoreFilterSubMenu
    ? hasAction(MoreFilterSubMenu, "InvoiceType")
    : false;
  const expiryDate = MoreFilterSubMenu
    ? hasAction(MoreFilterSubMenu, "ExpiryDate")
    : false;
  const showAllInvoices = approvedSubMenu
    ? hasAction(approvedSubMenu, "showAllInvoices")
    : false;

  const handlePageSizeChange = (event) => {
    setPageSizePending(event.target.value);
  };

  const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
  const handleChange = (event) => {
    setTpe(event.target.value);
  };

useEffect(() => {
  setTpe(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
}, [tab])


  useEffect(() => {
    setFilterType(type);
  }, [type]);
  return (
    <>
      <div className="card">
        <div className="card-header">
          {canApprove && (
            <button
              className="btn btn-success dz-xs-flex m-r5"
              style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" }}
              disabled={isLoading || getCheckedRows().length === 0}
              onClick={() => {
                const values = getCheckedRows();
                const idsArray = values.map((invoice) => ({
                  InvoiceId: invoice.Id,
                  FileId: invoice.FileId,
                }));

                handleActionMultipleApprove(idsArray);
                setCheckedRows([]);
                setIsAllChecked(false);
              }}
            >
              {isLoading ? " Submitting For Approval" : " Submit For Approval"}
            </button>
          )}
        </div>
        <div className="card-body">
        <div style={{display:'flex',justifyContent:'space-between'}}>
        <h4 style={{marginTop:"10px",marginRight:'10px'}}>Total Invoices : &nbsp; {totalCount}</h4>
        <div className="d-flex justify-content-end">
                    {checkedRows?.length!==0? (
            <div style={{display:'flex',marginTop:'12px',marginRight:'10px'}}>
                 <h5 style={{marginRight:'10px'}}>Selected Invoices : {checkedRows?.length}</h5>
                 <h5>Total Amount : {currencyFormat(totalAmount)}</h5>
            </div>
          ):null}
            {canSearch && (
              <div
                className="service-input-group input-group"
                style={{ width: "220px" }}
              >
                <span className="input-group-text search-input-icon">
                  <i className="bi bi-search" style={{ fontSize: "16px" }}></i>
                </span>
                <input
                  type="text"
                  className="form-control search-input"
                  id="val-username1"
                  placeholder="Search..."
                  name="username"
                  value={searchValuePagination}
                  onChange={handleSearchPagination}
                />
              </div>
            )}
            {MoreFilterSubMenu && (
              <Button
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{
                  textTransform: "none",
                }}
              >
                More Filters<span class="material-icons">arrow_drop_down</span>
              </Button>
            )}
            <ExpiryDateFilter
              onLoadData={() =>{
                onLoadData("InvoiceList", type);
                setTotalAmount(0)
                setCheckedRows([]);
                handleClose()
              }}
              open={open}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              anchorEl={anchorEl}
              handleClose={handleClose}
              setToDate={setToDate}
              type={type}
              handleChange={handleChange}
              showInvoiceType={invoiceType}
              showExpDate={expiryDate}
              //  setTpe={setTpe}
            />
          </div>
</div>
          <br />
          <h5 style={{marginRight:'10px',cursor:'pointer'}} onClick={handleHeaderCheckboxChange}> Select All </h5>
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{
                            color: "rgba(23, 90, 169, 0.78)",
                            width: "0px",
                            padding: "10px 0px",
                          }}
                        >
                          {canApprove && index === 0 ? (
                            <input
                             style={{margin:'5px'}}
                              type="checkbox"
                              checked={isAllChecked}
                              onChange={handleHeaderCheckboxChange}
                            />
                          ) : (
                            <>
                              {column.render("Header")}
                              {index !== 0 && (
                                <span className="ml-1">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              )}
                            </>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    const isRowExpanded = expandedRowIndex === rowIndex;
                    return (
                      <>
                        <tr
                          {...row.getRowProps()}
                          style={{
                            background: !isRowExpanded
                              ? rows[rowIndex].original.IsExpired
                                ? "rgb(255 0 0 / 20%) "
                                : "white"
                              : rows[rowIndex].original.IsExpired
                              ? "rgb(255 0 0 / 20%) "
                              : "#d3d3d3a8",
                            padding: "5px 0px",
                            margin: 0,
                          }}
                        >
                          {row.cells.map((cell, cellIndex) => {
                            const multipleSelect = cellIndex === 0;
                            const SupplierName = cellIndex === 1;

                            const InoiceNumber = cellIndex === 2;
                            const InvoiceType = cellIndex === 3;
                            const InvoiceDate = cellIndex === 4;
                            const TotalAmountVal = cellIndex === 5;
                            const LocationCode = cellIndex === 6;
                            const isLastColumn =
                              cellIndex === row.cells.length - 1;
                            const shouldHideInvoiceType =
                              cell.column.accessor === "InvoiceType" &&
                              permissionArr.some((permission) =>
                                permission.includes("Telephone")
                              );

                            return (
                              <td
                                {...cell.getCellProps()}
                                style={{
                                  color: "black",
                                  whiteSpace: "normal",
                                  padding: "5px 0px",
                                  margin: 0,
                                }}
                              >
                                {isLastColumn ? (
                                  <div style={{width:'90px'}}>
                                    {canEdit && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {"edit"}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="material-icons"
                                          style={{
                                            color: "rgba(233, 133, 35, 0.84)",
                                            cursor: "pointer",
                                            width: "18px",
                                            height: "20px",
                                            marginRight: "6px",
                                          }}
                                          onClick={() => {
                                            handleActionPending(
                                              rows[rowIndex].original.Id,
                                              "edit",
                                              rows[rowIndex].original
                                            );
                                          }}
                                        >
                                          edit
                                        </i>
                                      </OverlayTrigger>
                                    )}
                                    {/* {(permissionArr[0].includes("CustomerChecker")||permissionArr[0].includes("LocationChecker")) &&      <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip">{"veiw"}</Tooltip>
                                    }
                                  >
                                     <i
                                      className="material-icons"
                                      style={{
                                        color: "rgba(23, 90, 169, 0.78)",
                                        marginRight: "6px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        handleActionPending(rows[rowIndex].original.Id, "view", rows[rowIndex].original);
                                      }}
                                    >
                                      visibility
                                    </i>
                                  </OverlayTrigger>} */}
                                    {canAudittrial && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {"Audit"}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="material-icons"
                                          style={{
                                            color: "rgba(23, 90, 169, 0.78)",
                                            marginRight: "6px",
                                            cursor: "pointer",
                                            width: "18px",
                                            height: "20px",
                                          }}
                                          onClick={() => {
                                            handleActionPending(
                                              rows[rowIndex].original.Id,
                                              "audit",
                                              rows[rowIndex].original
                                            );
                                          }}
                                        >
                                          history
                                        </i>
                                      </OverlayTrigger>
                                    )}
                                    {canReject && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {"Reject"}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="material-icons"
                                          style={{
                                            color: "red",
                                            marginRight: "6px",
                                            cursor: "pointer",
                                            width: "18px",
                                            height: "20px",
                                          }}
                                          onClick={() => {
                                            handleActionPending(
                                              rows[rowIndex].original.Id,
                                              "cancel",
                                              rows[rowIndex].original
                                            );
                                          }}
                                        >
                                          block
                                        </i>
                                      </OverlayTrigger>
                                    )}
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip">
                                          {"Expand"}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        className="material-icons"
                                        style={{
                                          cursor: "pointer",
                                          width: "18px",
                                          height: "18px",
                                        }}
                                        onClick={() => {
                                          toggleRowExpansion(
                                            rowIndex,
                                            rows[rowIndex].original
                                          );
                                        }}
                                      >
                                        {isRowExpanded ? "remove" : "add"}
                                      </i>
                                    </OverlayTrigger>
                                  </div>
                                ) : (
                                  (canApprove && multipleSelect && (
                                    <input
                                     style={{margin:'5px'}}
                                      type="checkbox"
                                      checked={checkedRows.includes(row.id)}
                                      onChange={() => handleCheckboxChange(row)}
                                    />
                                  )) ||
                                  // (SupplierName && cell.render("Cell")) ||
                                  // (InoiceNumber && cell.render("Cell")) ||
                                  // (/telephone/i.test(permissionArr[0]) ?null:
                                  // (InvoiceType && cell.render("Cell")))||
                                  // (InvoiceDate && formatDate(rows[rowIndex].original.InvoiceDate)) ||
                                  // (TotalAmountVal &&currencyFormat(rows[rowIndex].original.TotalAmount))||
                                  // (LocationCode && cell.render("Cell")) ||
                                  // cell.render("Cell")

                                  (cell.column.id === "SupplierName" &&
                                    cell.render("Cell")) ||
                                  (cell.column.id === "InvoiceNo" &&
                                    cell.render("Cell")) ||
                                  (!shouldHideInvoiceType &&
                                    cell.column.id === "InvoiceType" &&
                                    cell.render("Cell")) ||
                                  (cell.column.id === "InvoiceDate" &&
                                    formatDate(
                                      rows[rowIndex].original.InvoiceDate
                                    )) ||
                                  (cell.column.id === "TotalAmount" &&
                                    currencyFormat(
                                      rows[rowIndex].original.TotalAmount
                                    )) ||
                                  (cell.column.id === "CurrentMonthTotalPayableCharges" &&
                                 (
                                  <>
                                  <div style={{textAlign:"center"}}>
                                    {currencyFormat(
                                      rows[rowIndex].original.CurrentMonthTotalPayableCharges
                                    )}
                                  </div>
                                  </>
                                 )
                                  ) ||
                                  (cell.column.id === "LocationCode" &&
                                    cell.render("Cell")) ||
                                  cell.render("Cell")
                                )}
                              </td>
                            );
                          })}
                        </tr>

                        {isRowExpanded && (
                          <tr>
                            <td colSpan={headerGroups[0].headers.length}>
                              <div
                                className="expanded-content"
                                style={{
                                  backgroundColor: "lightgrey",
                                  padding: "10px",
                                  borderRadius: "5px",
                                }}
                              >
                                {/* <h5>Expanded Data</h5> */}

                                {labels.map((label, index) => (
                                  <div className="row">
                                    <div className="col-3  d-flex flex-column">
                                      <label
                                        key={index}
                                        style={{
                                          whiteSpace: "normal",
                                          fontWeight: "600",
                                          color: "black",
                                        }}
                                      >
                                        {label.key}
                                      </label>
                                    </div>
                                    <div className="col-9 d-flex flex-column">
                                      <label
                                        key={index}
                                        style={{
                                          whiteSpace: "normal",
                                          color: "black",
                                        }}
                                      >
                                        {label.value}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    );
                  })}
                </tbody>
                {showLoading && <SkeletonTableRow cols={6} row={6} />}
              </table>
              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}
            </div>
          </div>
          {/* Pagination & Page Size */}
          <div className="pagination-container d-flex justify-content-between">
            <div style={{ marginTop: "20px" }}>
              <label htmlFor="pageSizeSelect">Rows per page: </label>
              <select
                id="pageSizeSelect"
                value={pageSizePagination}
                onChange={handlePageSizeChange}
                style={{ marginLeft: "10px" }}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={250}>250</option>
                <option value={500}>500</option>
              </select>
            </div>

            {/* <PaginationAndSearching
            searchValue={searchValuePagination}
            handleSearch={handleSearchPagination}
            totalCount={totalCountPagination}
            pageSize={pageSizePagination}
            onPageChange={handleOnChangePagination}
            showLoading={showLoading}
          /> */}

            <PaginationAndSearching
              handleSearch={handleSearchPagination}
              searchValue={searchValuePagination}
              defaultValue={pageSizePagination}
              handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
              totalCount={totalCountPagination}
              onChange={(e, p) => {
                handleOnChangePagination(e, p);
                setCheckedRows([]);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingInvoiceTable;
